import { createContext, Dispatch, SetStateAction } from 'react';

import { InventoryTree } from '@scaleaq/sitecontrol-lib';

import { useRequiredContext } from '@/hooks';

export interface InventoryContextType {
  inventory: InventoryTree[];
  isFetching: boolean;
  getInventoryNameById: (sourceId: string) => string;
  getInventoryIdByName: (sourceName?: string) => string | undefined;
  setEventId: Dispatch<SetStateAction<string>>;
  closeModal: () => void;
}

export const InventoryContext = createContext<InventoryContextType | undefined>(undefined);

export const useInventoryContext = (): InventoryContextType =>
  useRequiredContext({
    context: InventoryContext,
    hookName: 'useInventoryContext',
    providerName: 'an InventoryProvider',
  });
